/**
 * Stack Card Color Palette Constants
 * Colors are numbered for maintainability - hex values may change
 */

// Default color
export const STACK_COLOR_DEFAULT_ACCENT = '#DDE3EE';
export const STACK_COLOR_DEFAULT_BACKGROUND = '#F7F9FC';

// Palette options (numbered to allow hex changes without renaming)
export const STACK_PALETTE_01_ACCENT = '#DDE3EE';     // Light Gray
export const STACK_PALETTE_01_BACKGROUND = '#F7F9FC';
export const STACK_PALETTE_02_ACCENT = '#FFD1DC';     // Pink
export const STACK_PALETTE_02_BACKGROUND = '#FFF6F8';
export const STACK_PALETTE_03_ACCENT = '#FFE5B4';     // Yellow
export const STACK_PALETTE_03_BACKGROUND = '#FFFAF0';
export const STACK_PALETTE_04_ACCENT = '#D4DAFF';     // Purple
export const STACK_PALETTE_04_BACKGROUND = '#F6F8FF';
export const STACK_PALETTE_05_ACCENT = '#A8F0E6';     // Teal
export const STACK_PALETTE_05_BACKGROUND = '#EEFCFA';
export const STACK_PALETTE_06_ACCENT = '#FFCCCC';     // Coral
export const STACK_PALETTE_06_BACKGROUND = '#FFF5F5';
export const STACK_PALETTE_07_ACCENT = '#C7E0FF';     // Blue
export const STACK_PALETTE_07_BACKGROUND = '#F4F9FF';
export const STACK_PALETTE_08_ACCENT = '#FFD6C0';     // Orange
export const STACK_PALETTE_08_BACKGROUND = '#FFF7F2';
export const STACK_PALETTE_09_ACCENT = '#8BC34A';     // Green
export const STACK_PALETTE_09_BACKGROUND = '#E8F3DB';
export const STACK_PALETTE_10_ACCENT = '#B2F0F7';     // Cyan
export const STACK_PALETTE_10_BACKGROUND = '#F0FCFD';

// Color options array for Storybook and selectors
export const STACK_COLOR_OPTIONS = [
  undefined,
  STACK_PALETTE_01_ACCENT,
  STACK_PALETTE_02_ACCENT,
  STACK_PALETTE_03_ACCENT,
  STACK_PALETTE_04_ACCENT,
  STACK_PALETTE_05_ACCENT,
  STACK_PALETTE_06_ACCENT,
  STACK_PALETTE_07_ACCENT,
  STACK_PALETTE_08_ACCENT,
  STACK_PALETTE_09_ACCENT,
  STACK_PALETTE_10_ACCENT,
];

// Palette array for testing
export const STACK_COLOR_PALETTE = [
  { accent: STACK_PALETTE_01_ACCENT, background: STACK_PALETTE_01_BACKGROUND },
  { accent: STACK_PALETTE_02_ACCENT, background: STACK_PALETTE_02_BACKGROUND },
  { accent: STACK_PALETTE_03_ACCENT, background: STACK_PALETTE_03_BACKGROUND },
  { accent: STACK_PALETTE_04_ACCENT, background: STACK_PALETTE_04_BACKGROUND },
  { accent: STACK_PALETTE_05_ACCENT, background: STACK_PALETTE_05_BACKGROUND },
  { accent: STACK_PALETTE_06_ACCENT, background: STACK_PALETTE_06_BACKGROUND },
  { accent: STACK_PALETTE_07_ACCENT, background: STACK_PALETTE_07_BACKGROUND },
  { accent: STACK_PALETTE_08_ACCENT, background: STACK_PALETTE_08_BACKGROUND },
  { accent: STACK_PALETTE_09_ACCENT, background: STACK_PALETTE_09_BACKGROUND },
  { accent: STACK_PALETTE_10_ACCENT, background: STACK_PALETTE_10_BACKGROUND },
];